import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

import {IRadiobox, Radiobox} from "components/CheckRadiobox";
import {IcoInfo, TitleH2, TitleH3} from "components/generic";
import Select, {ISelect} from "components/Select";
import {IInputHookOut, InputLabel} from "components/Input";
import {ISelectItems, TMode} from "interfaces/intarfaces";
import {InfoMessage, RadioboxPlace, RoomDetailsWrapper, TypeRoomContainer, TypeRoomWrapper,} from "./styles";

import {getAllProvinces, getCountries} from "utils/fetchMapInfo";
import {TYPE_ROOM} from "utils/constants";

import {TLang} from "assets/data/isoNameLanguage";

interface IRoomsDetails {
  modeView: TMode;
  typeRoom: Partial<IRadiobox>;
  titleRoom: IInputHookOut;
  country: ISelect;
  province: ISelect;
  postalCode: IInputHookOut;
  houseNumber: IInputHookOut;
  addition: IInputHookOut;
  street: IInputHookOut;
  city: IInputHookOut;
  isDisabled?: boolean;
}
export const RoomsDetails: React.FC<IRoomsDetails> = ({
  modeView,
  typeRoom,
  titleRoom,
  country,
  province,
  postalCode,
  houseNumber,
  addition,
  street,
  city,
}) => {
  const { t, i18n } = useTranslation("hostrooms");
  const [provinces, setProvinces] = useState<ISelectItems[]>(
    getAllProvinces(country.value as string)
  );

  const currLang = i18n.language.toUpperCase() as TLang;

  useEffect(() => {
    setProvinces(getAllProvinces(country.value as string));
  }, [country.value]);

  useEffect(() => {
    // if (province.value) {
    //   let citiesProvince: ISelectItems[] = getCities(
    //     province.value as string,
    //     country.value as string,
    //     currLang
    //   );
    //   setCities(citiesProvince);
    //   if (
    //     city.value &&
    //     !citiesProvince.map((item) => item.value).includes(city.value)
    //   ) {
    //     city.changeItem("");
    //   }
    // }

    // eslint-disable-next-line
  }, [province.value]);

  const titleID = (keyItem: string) => {
    return {
      title: t(`roomsDetails.${keyItem}.title`),
      placeholder: t(`roomsDetails.${keyItem}.placeholder`),
      id: keyItem,
    };
  };

  const paddingRadiobox = () =>
    modeView === "create" ? "0.9em 1em 0.9em 1.3em" : "0.2rem 1em 0.2em 0";

  return (
    <RoomDetailsWrapper>
      <TypeRoomWrapper id="typeRoomBox">
        <TitleH2 m="0 0 16px 0" id="roomsDetailsAnchor">
          {t("roomsDetails.title")}
        </TitleH2>
        <TitleH3>{t("roomsDetails.typeRoom.title")}</TitleH3>
        <TypeRoomContainer error={province.required && !typeRoom.selected}>
          {TYPE_ROOM.map((item, num) => (
            <RadioboxPlace
              modeView={modeView}
              key={item}
              id={item}
              active={typeRoom.selected === item && modeView === "create"}
            >
              <Radiobox
                {...typeRoom}
                title={t(`roomsDetails.typeRoom.items.${item}.title`)}
                value={`${item}`}
                p={paddingRadiobox()}
              />
              <InfoMessage
                left={`${-4 * (num + 1) * 1.2}em`}
                message={t(`roomsDetails.typeRoom.items.${item}.tooltip`)}
              >
                <IcoInfo size="1.2em" />
              </InfoMessage>
            </RadioboxPlace>
          ))}
        </TypeRoomContainer>
      </TypeRoomWrapper>
      <InputLabel
        {...titleRoom}
        {...titleID("titleRoom")}
        type="text"
        maxLength={50}
        disabled={modeView === "re-publish"}
      />
      <Select
        {...country}
        {...titleID("countryRoom")}
        items={getCountries(currLang)}
        disabled
      />
      <Select
        {...province}
        {...titleID("stateRoom")}
        items={provinces}
        disabled={modeView === "re-publish"}
      />
      <InputLabel
        {...postalCode}
        {...titleID("postalCode")}
        maxLength={6}
        pattern="[0-9]{4}[A-Za-z]{2}"
        disabled={modeView === "re-publish"}
      />
      <InputLabel
        {...houseNumber}
        {...titleID("houseNumber")}
        maxLength={5}
        disabled={modeView === "re-publish"}
      />
      <InputLabel
        {...addition}
        {...titleID("addition")}
        maxLength={5}
        disabled={modeView === "re-publish"}
      />
      <InputLabel
        {...street}
        {...titleID("streetRoom")}
        maxLength={100}
        disabled={modeView === "re-publish"}
      />
      <InputLabel
        {...city}
        {...titleID("cityRoom")}
        maxLength={100}
        disabled={modeView === "re-publish"}
      />
      {/* <Select
        {...city}
        {...titleID("cityRoom")}
        items={cities}
        disabled={modeView === "re-publish"}
      /> */}
    </RoomDetailsWrapper>
  );
};

